angular.module('dnecom')
   .directive('formErrors', function() {
        return {
            restrict: "E",
            transclude: true,
            scope: {
                element: '=element',
                errorMessages: '=errorMessages'
            },
            template:
                '<div ng-messages="element.$error" ng-if="element.$touched && element.$invalid" class="form-group-errors">'
                    + '<div ng-transclude></div><div ng-messages-include="error-messages"></div>'
                    + '<div ng-repeat="errorMessage in errorMessages">'
                        + '<div class="text-danger" ng-message-exp="errorMessage.type">{{ errorMessage.text }}</div>'
                    + '</div>'
                + '</div>'
        };
    })
;
